"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = require("react");
const react_popper_1 = require("react-popper");
const downshift_1 = require("downshift");
const useDropdownMenu = ({ items, placement = 'bottom-start', itemToString = (item) => item, offset = [0, 10], loopItemsOnKeyDown = true, closeMenuOnLastItem = false, closeMenuOnFirstItem = false, resetSelectedItemOnClose = false }) => {
    const [referenceElement, setReferenceElement] = (0, react_1.useState)(null);
    const [popperElement, setPopperElement] = (0, react_1.useState)(null);
    const modifiers = (0, react_1.useMemo)(() => [
        {
            name: 'sameWidth',
            enabled: true,
            fn: ({ state }) => {
                state.styles.popper.width = `${state.rects.reference.width}px`;
            },
            phase: 'beforeWrite',
            requires: ['computeStyles']
        },
        {
            name: 'offset',
            options: {
                offset
            }
        }
    ], []);
    const { styles, attributes, update } = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        placement,
        modifiers
    });
    const stateReducer = (state, actionAndChanges) => {
        const { type, changes } = actionAndChanges;
        switch (type) {
            case downshift_1.useSelect.stateChangeTypes.MenuKeyDownArrowDown:
                if (closeMenuOnLastItem && state.highlightedIndex === items.length - 1) {
                    return {
                        ...changes,
                        isOpen: false
                    };
                }
                if (state.highlightedIndex === items.length - 1 && loopItemsOnKeyDown) {
                    let newHighlightedIndex = 0;
                    //if the first item is a header set the highlighted index to 1
                    if (items[0].header) {
                        newHighlightedIndex = 1;
                    }
                    return {
                        ...changes,
                        isOpen: true,
                        highlightedIndex: newHighlightedIndex
                    };
                }
                return {
                    ...changes,
                    isOpen: true
                };
            case downshift_1.useSelect.stateChangeTypes.MenuKeyDownArrowUp:
                if (closeMenuOnFirstItem && state.highlightedIndex === 0) {
                    return {
                        ...changes,
                        isOpen: false,
                        highlightedIndex: -1
                    };
                }
                // if the first item is a header and the user is on the first
                // item, set the highlighted index to the last item
                if (state.highlightedIndex === 1 && items[0].header && loopItemsOnKeyDown) {
                    return {
                        ...changes,
                        isOpen: true,
                        highlightedIndex: items.length - 1
                    };
                }
                if (state.highlightedIndex === 0 && loopItemsOnKeyDown) {
                    return {
                        ...changes,
                        isOpen: true,
                        highlightedIndex: items.length - 1
                    };
                }
                return {
                    ...changes,
                    isOpen: true
                };
            case downshift_1.useSelect.stateChangeTypes.MenuKeyDownEnter:
            case downshift_1.useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
                if (items[state.highlightedIndex] && items[state.highlightedIndex].menuItems) {
                    return {
                        ...changes,
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    };
                }
                if (type === downshift_1.useSelect.stateChangeTypes.MenuKeyDownEnter) {
                    if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick)
                        items[state.highlightedIndex].onClick();
                }
                if (resetSelectedItemOnClose) {
                    return {
                        ...changes,
                        isOpen: false,
                        selectedItem: -1,
                        highlightedIndex: -1
                    };
                }
                return {
                    ...changes
                };
            case downshift_1.useSelect.stateChangeTypes.ItemClick:
                if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick)
                    items[state.highlightedIndex].onClick();
                if (resetSelectedItemOnClose) {
                    return {
                        ...changes,
                        isOpen: false,
                        selectedItem: -1,
                        highlightedIndex: -1
                    };
                }
                return {
                    ...changes
                };
            default:
                return changes; // otherwise business as usual.
        }
    };
    const { isOpen, getToggleButtonProps, getMenuProps, highlightedIndex, selectedItem, getItemProps } = (0, downshift_1.useSelect)({
        items,
        itemToString,
        stateReducer
    });
    (0, react_1.useEffect)(() => {
        update && update();
    }, [isOpen]);
    return {
        isOpen,
        getToggleButtonProps,
        getMenuProps,
        highlightedIndex,
        selectedItem,
        getItemProps,
        setReferenceElement,
        setPopperElement,
        attributes,
        styles,
        update
    };
};
exports.default = useDropdownMenu;
